import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { ButtonBase } from '#src/atoms/buttons/ButtonBase/index.tsx';
import { BodyM, BodyS } from '#src/atoms/typography/index.tsx';
import { HorizontalDivider } from '#src/atoms/ui/Divider/index.tsx';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { glossary } from '#src/lib/glossary.ts';

import { UpdateNameDialog } from './UpdateNameDialog/index.tsx';

const StyledButtonBase = styled(ButtonBase)`
  color: var(--c-link);
  text-decoration: underline;
`;

export const UpdateName = () => {
  const { fiatWalletAccountable } = useCurrentUserContext();
  const { firstName, lastName } = fiatWalletAccountable || {};
  const [openDialog, setOpenDialog] = useState(false);
  if (!firstName || !lastName) return null;
  return (
    <>
      <div>
        <BodyM>
          <FormattedMessage {...glossary.name} />
        </BodyM>
        <BodyS color="var(--c-nd-600)">
          {firstName} {lastName}
        </BodyS>
        <StyledButtonBase onClick={() => setOpenDialog(true)}>
          <BodyS bold color="var(--c-link)">
            <FormattedMessage {...glossary.edit} />
          </BodyS>
        </StyledButtonBase>
        <UpdateNameDialog
          open={openDialog}
          onClose={() => setOpenDialog(false)}
        />
      </div>
      <HorizontalDivider />
    </>
  );
};
